<template>
    <div class="multiple-upload">
        <div class="flex">
            <div class="img-group" v-for="(item, idx) in fileList" :key="item.fileUrl">
                <img @click="preview(item)" class="perview-img" :src="item.fileUrl" alt="" />
                <i v-if="!disabled" @click="del(idx)" class="el-icon-error"></i>
            </div>
        </div>
        <el-upload
            class="upload-group"
            ref="upload"
            action=""
            multiple
            :disabled="loading"
            :limit="limit"
            :file-list="fileList"
            :show-file-list="false"
            :on-exceed="handleExceed"
            :before-upload="getUploadInfo"
            :http-request="addAttachment"
            :accept="'image/*'">
            <el-button :loading="loading" type="primary" v-if="fileList.length < limit">选择文件</el-button>
            <!-- <div slot="tip" class="el-upload__tip">只能上传Excel文件，且不超过{{ SRM_FILE_MAX_SIZE }}MB</div> -->
        </el-upload>

        <preview
            :attachmentList="attachmentList"
            v-if="attachmentShow"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"></preview>
    </div>
</template>
<script>
import { ossUpload } from '../../../../../../api/uploadAndDownload.js'
import preview from '../../../../../../components/viewAttachment.vue'
// import { SRM_FILE_PRE, SRM_FILE_MAX_SIZE, SRM_FILE } from '../../../../../../constant/constant.js'
const THOUSAND_TWENTY_FOUR = 1024
const SRM_FILE_MAX_SIZE = 3
export default {
    components: {preview},
    props: {
        exportTemplate: {
            type: Function,
            default() {
                return () => {}
            },
        },
        fileList: {
            type: Array,
            default() {
                return []
            },
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            attachmentList: [],
            attachmentShow: false,
            rowData: {},
            limit: 10,
            SRM_FILE_MAX_SIZE,
            loading: false,
            assessmentCategory: '',
        }
    },
    computed: {},
    methods: {
        preview(row) {
            this.rowData = {
                downUrl: row.fileUrl,
                fileName: row.fileName,
                fileId: row.fileId,
            }
            this.attachmentList = this.fileList.map(v => v.fileUrl)
            this.attachmentShow = true
        },
        del(idx) {
            this.fileList.splice(idx, 1)
        },
        handleConfirm() {
            this.$refs.upload.submit()
        },
        handleExceed(files, fileList) {
            debugger
            this.$message.warning(`最多上传${this.limit}个图片`)
        },
        // 文件名处理
        handleFileNameAndSize(file) {
            const index = file.name.lastIndexOf('.')
            const originName = file.name
                .substring(0, index)
                .replace(
                    /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/gi,
                    '',
                )
                .replace(/\s+/g, '')
            const originNameType = file.name.substring(index, file.length)
            return originName + originNameType
        },
        getUploadInfo(file) {
            // 不允许上传不可预览格式文件
            let uploadTypeReg = /\.(jpg|jpeg|png)$/
            let fileType = file.name.slice(file.name.lastIndexOf('.'))

            if (!uploadTypeReg.test(fileType.toLowerCase())) {
                this.$message.warning('不支持上传' + fileType + '格式文件')
                return false
            }
            if (file.size >= SRM_FILE_MAX_SIZE * THOUSAND_TWENTY_FOUR * THOUSAND_TWENTY_FOUR) {
                this.$message.warning('上传文件不能大于' + SRM_FILE_MAX_SIZE + 'MB')
                return false
            }
        },
        addAttachment(file) {
            this.loading = true
            const fileName = this.handleFileNameAndSize(file.file)
            const fileData = new File([file.file], fileName, {
                type: file.file.type,
            })

            ossUpload(fileData, {
                bucket: 'srm',
                businessKey: '',
                publicRead: 1,
                callback: null,
            })
                .then(res => {
                    if (res && +res.code === 0) {
                        // const lastPoint = res.data.downUrl.lastIndexOf('.')
                        // res.data.type = res.data.downUrl.slice(lastPoint + 1)
                        this.fileList.push({
                            fileUrl: decodeURIComponent(res.data.downUrl),
                            fileId: new Date().getTime(),
                            fileName,
                        })
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
    mounted() {},
}
</script>
<style lang="less" scoped>
.multiple-upload {
    width: 500px;
    .upload-group {
        position: relative;
        line-height: 0;
        .el-upload {
            margin-bottom: 20px;
        }

        .el-upload__tip {
            position: absolute;
            top: 0;
            left: 100px;
            font-size: 12px;
        }
    }

    .el-button {
        font-size: 14px;
    }
    .perview-img {
        width: 80px;
        height: 80px;
        border-radius: 4px;
        margin-right: 10px;
    }
    .flex {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .img-group {
        cursor: pointer;
        position: relative;
        .el-icon-error {
            position: absolute;
            top: -8px;
            right: 0;
            font-size: 22px;
            background: #fff;
            border-radius: 50%;
        }
    }
}
</style>
